import { cycleTheme, useTheme } from '../lib/theme';

const LABEL: Record<string, string> = { system: '◐ Auto', light: '☀ Light', dark: '☾ Dark' };

export default function ThemeToggle({ className = 'themeBtn' }: { className?: string }) {
  const pref = useTheme();
  return (
    <button type="button" className={className} onClick={cycleTheme} aria-label="Change theme">
      {LABEL[pref]}
    </button>
  );
}
